import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

export const StudentAddressCountryName = "student-mailing-address-country";

export function StudentAddressCountry({
  label = "Student Country of Residence",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: StudentAddressCountryName,
        type: "countryselect",
        name: StudentAddressCountryName,
        label: label,
        validate: { presence: true },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "w-full" }}
    />
  );
}
